import {
    GET_DEALERS_REQUEST,
    GET_DEALERS_SUCCESS,
    GET_DEALERS_FAILURE,
    SET_DEALERS,
    SET_DEALER,
    SUBMIT_DEALER_REQUEST,
    SUBMIT_DEALER_SUCCESS,
    SUBMIT_DEALER_FAILURE,
    DELETE_DEALER_REQUEST,
    DELETE_DEALER_SUCCESS,
    DELETE_DEALER_FAILURE
} from '../actions/dealers';
import { buildDealers } from '../helpers/dealers';

const initialState = {
    dealers: [],
    dealer: {},
    fetching: false,
    total: 0,
    submitFetching: false,
    submitSuccess: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DEALERS_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_DEALERS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                dealers: buildDealers(action.payload.dealers, action.payload.companies),
                total: action.payload.total !== 0 ? action.payload.total : state.total
            };
        }
        case GET_DEALERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_DEALERS: {
            return {
                ...state,
                dealers: action.payload.dealers,
                total: action.payload.total,
                fetching: !action.payload.dealers.length
            };
        }
        case SET_DEALER: {
            return {
                ...state,
                dealer: action.payload.dealer
            };
        }
        case SUBMIT_DEALER_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_DEALER_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_DEALER_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case DELETE_DEALER_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case DELETE_DEALER_SUCCESS: {
            return {
                ...state,
                fetching: false,
                dealers: state.dealers.filter(dealer => dealer.identifier !== action.payload.dealer.identifier)
            };
        }
        case DELETE_DEALER_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default:
            return state;
    }
};
